import { useState } from "react";

export const useResultsSelection = ({ filteredData, getItemId }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const visibleIds = new Set(filteredData.map(getItemId));
  const activeSelectedIds = selectedIds.filter((id) => visibleIds.has(id));

  const clearSelection = () => setSelectedIds([]);

  const selection = {
    selectedCount: activeSelectedIds.length,
    isSelected: (id) => activeSelectedIds.includes(id),
    toggleSelection: (id, _row, checked) =>
      setSelectedIds((prev) =>
        checked ? [...prev, id] : prev.filter((i) => i !== id)
      ),
    selectAll: (data) =>
      setSelectedIds((prev) => [
        ...new Set([...prev, ...data.map(getItemId)]),
      ]),
    deselectAll: () => setSelectedIds([]),
  };

  return { selection, clearSelection };
};
